import React from 'react';
import MainButton from '../components/MainButton/MainButton';
import "./Main.scss"

export default function Main(){
  return (
    <>
      <main className="main">
        <h1>Scalable Vector Graphics tool</h1>
        <hr />
        <MainButton title={"Create svg marker"} link={"create-svg-marker"}/>
        <MainButton title={"Create svg polygon"} link={"create-svg-polygon"}/>
      </main>
    </>
  );
};
